import React, { useMemo } from 'react';
import { Home, RotateCcw, Archive, FileText, Calendar } from 'lucide-react';
import { useProperties } from '../hooks/useProperties';
import { PropertyCategoryView } from '../components/properties/PropertyCategoryView';
import { Button } from '../components/ui/Button';
import { Counter } from '../components/ui/Counter';
import { useNavigate } from 'react-router-dom';

export const RentedList: React.FC = () => {
  const { properties, isLoading, updateProperty } = useProperties();
  const navigate = useNavigate();

  const rentedProperties = useMemo(
    () => properties.filter(p => p.status === 'rented'),
    [properties]
  );

  const handleGenerateReport = () => {
    // TODO: Implémenter la génération de rapport des locations
    console.log('Générer rapport des locations');
  };
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-3">
              <Home className="h-8 w-8 text-blue-500" />
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                Biens loués
              </h1>
            </div>
            <Counter 
              count={rentedProperties.length} 
              label={rentedProperties.length > 1 ? "biens loués" : "bien loué"}
              variant="info"
            />
          </div>
          <div className="flex items-center gap-4">
            <Button 
              variant="secondary"
              onClick={handleGenerateReport}
              className="flex items-center gap-2"
            >
              <FileText className="h-5 w-5" />
              Rapport des locations
            </Button>
          </div>
        </div>

        <PropertyCategoryView
          title=""
          properties={rentedProperties}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};